export const ASSISTANT_SET_OPEN = 'ASSISTANT_SET_OPEN';
export const ASSISTANT_LOAD_MESSAGES = 'ASSISTANT_LOAD_MESSAGES';
export const ASSISTANT_LOAD_MESSAGES_SUCCESS =
  'ASSISTANT_LOAD_MESSAGES_SUCCESS';
export const ASSISTANT_LOAD_MESSAGES_FAILURE =
  'ASSISTANT_LOAD_MESSAGES_FAILURE';
export const ASSISTANT_SEND_MESSAGE = 'ASSISTANT_SEND_MESSAGE';
export const ASSISTANT_SEND_MESSAGE_SUCCESS = 'ASSISTANT_SEND_MESSAGE_SUCCESS';
export const ASSISTANT_SEND_MESSAGE_FAILURE = 'ASSISTANT_SEND_MESSAGE_FAILURE';
export const ASSISTANT_CLEAR_MESSAGES = 'ASSISTANT_CLEAR_MESSAGES';
